<template>
    <div class="Listing" v-loading="fullscreenLoading" v-if="property && property.int_property_id">
        <ListingHeader :property="property"/>
        <div class="row">
            <div class="col-xs-12">
                <ListingImages />
            </div>
        </div>
        <div class="row center-xs">
            <div class="col-xs-12 col-sm-6 start-sm">
                <h3 class="Listing__Heading">
                    {{language ==='english' ? property.str_property_name_en : property.str_property_name_jp}}
                    <span v-if="property.str_apartment_no && property.str_apartment_no !== 'N/A' && property.str_apartment_no !== 'NA'">{{ '#' + property.str_apartment_no}}</span>
                </h3>
                <p class="Listing__Address" v-if="language ==='english'">{{property.ward ? property.ward.str_ku_shi_name_en + ' - ' : ''}} {{property.city ? property.city.name : ''}} </p>
                <p class="Listing__Address" v-else>{{property.ward ? property.ward.str_ku_shi_name_jp + ' - ' : ''}} {{property.city ? property.city.name_jp : ''}} </p>
            </div>
            <div class="col-xs-12 col-sm-6 end-sm">
                <h3 class="Listing__Price" v-if="property.price > 0 && !property.bit_inquiry && !property.bit_inquiry_all">{{property.price | currency('¥',0)}}</h3>
                <h3 class="Listing__Price" v-else>{{'Please Inquire' | language}}</h3>
                <p class="Listing__PerMonth" >{{'Per Month' | language}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-8">
                <hr>
                <ListingIcons :property="property" />
                <ListingOverview :property="property" />
                <ListingCosts :property="property" />
                <ListingLocation :property="property" />
                <ListingTrainDistance :building="property.building" v-if="property.building"/>
                <ListingDescription :property="property" />
            </div>

            <div class="col-xs-12 col-md-4">
                <ListingEnquiry :propertyId ="property.int_property_id"/>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <ListingRelatedProperties :building="property.building" :propertyId="property.int_property_id"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ListingHeader from '@/components/Listing/ListingHeader'
    import ListingImages from '@/components/Listing/ListingImages'
    import ListingEnquiry from '@/components/Listing/ListingEnquiry'
    import ListingRelatedProperties from '@/components/Listing/ListingRelatedProperties'
    import ListingDescription from '@/components/Listing/ListingDescription'
    import ListingLocation from '@/components/Listing/ListingLocation'
    import ListingTrainDistance from '@/components/Listing/ListingTrainDistance'
    import ListingCosts from '@/components/Listing/ListingCosts'
    import ListingOverview from '@/components/Listing/ListingOverview'
    import ListingIcons from '@/components/Listing/ListingIcons'
    import { mapState } from 'vuex'

    export default {
        components: {
            ListingHeader,
            ListingImages,
            ListingIcons,
            ListingEnquiry,
            ListingRelatedProperties,
            ListingDescription,
            ListingLocation,
            ListingTrainDistance,
            ListingCosts,
            ListingOverview,
        },
        props: {
        },
        data: function() {
            return {
                fullscreenLoading: false,
            }
        },
        computed: {
            ...mapState({
                property: (state) => {
                    return state.property.property
                },
                language: (state) => {
                    return state.general.language
                }
            })
        },

        created() {
            this.fetProperty()
        },
        watch: {
            '$route.params':function(){
                this.fetProperty()
            }
        },
        destroyed() {
        },
        methods: {
            fetProperty() {
                this.fullscreenLoading = true
                const promise = this.$store.dispatch('property/getProperty',this.$route.params.id);
                promise
                .then(()=>{
                    this.$emit('updateHead')
                })
                .catch(() =>{
                    this.$router.push({path: '/search',query: this.$store.state.search.query})
                })
                .finally(() => {
                    this.fullscreenLoading = false
                })

            }
        },
        head: {
            title: function() {
                return {
                    inner: this.property.str_property_name_en
                }
            },
            meta: function () {
                return [
                    { name: 'title', content: this.property.str_property_name_en },
                    { name: 'keywords', content: 'japan home finder, japan realestate, apartment, house, for rent, for lease' },
                    { name: 'description', content: 'Making your Japan home search easier' }
                ]
            }
        }
    }
</script>

<style lang="scss">
    .Listing {
        // font-family: 'Proxima Nova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

        &__Price {
            color: #424242;
            margin-bottom: 0;
            margin-right: .5rem;
        }
        &__PerMonth {
            margin: 0;
            font-size: 1.2rem;
            text-transform: uppercase;
            font-weight: 700;
            color: lightgray;
            margin-right: .5rem;
        }

        &__LocationContainer {
            padding: 0;
        }

        @media only screen and (max-width: 992px) {
            .ListingEnquiry {
                position: initial;
            }
        }

        @media only screen and (max-width: 767px) {
            .Listing__HeaderButtons {
                margin: -.5em 0 0;
            }

            .ListingIcons__Icon {
                margin-right: 1em;

                img {
                    width: 20px;
                    height: 20px;
                }
            }

            table {
                font-size: 90%;
            }

            .ListingEnquiry {
                padding: 1rem;
            }

            .ListingImages {
                padding: 1rem 0;
            }
        }
    }

    .el-form-item__label {
        padding: 0 !important;
        margin: 0;
    }

    .el-form-item {
        margin: 0 !important;
    }
</style>


